/* eslint-disable react/require-default-props */
import React from 'react'
import DependencyValidator from '../dependency-validator'

import { Container, TitleEl } from './styles'

type IProps = any & {
  title: string
}

const Subtitle = ({
  title,
  ...el
}: IProps) => (
  <DependencyValidator {...el}>
    <Container {...el}>
      <TitleEl>{title}</TitleEl>
    </Container>
  </DependencyValidator>
)

export default Subtitle
